import { useMemo } from 'react';
import { Grid } from '@mui/system';
import ScalarDatasheet from 'components/ScalarDatasheet';
import { Cell, ValueEditor, ValueViewer } from 'components/Spreadsheet/components';
import { CompGroupsContext } from 'context';
import { TransactionsTableCompsProps } from './TransactionsTableComps.props';

const GpcTableComps = ({ onCellsChanged, transactionDataGrid }: TransactionsTableCompsProps) => {
  const contextValue = useMemo(() => ({ group: null, onCellsChanged }), [onCellsChanged]);

  return (
    <CompGroupsContext.Provider value={contextValue}>
      <Grid size={{ xs: 12 }}>
        {transactionDataGrid && (
          <ScalarDatasheet
            cellRenderer={Cell}
            className="comp-datasheet gpc-table-comps"
            data={transactionDataGrid}
            dataEditor={ValueEditor}
            onCellsChanged={onCellsChanged}
            valueViewer={ValueViewer}
          />
        )}
      </Grid>
    </CompGroupsContext.Provider>
  );
};

export default GpcTableComps;
